export default "__VITE_ASSET__1uK2Ahr0__"